<template>
  <div class="all-search">
    <div class="search">
      <div class="search-input">
        <input type="text" v-model="TitleName"  @keyup.enter="ToSearch" placeholder="搜索你喜欢的……" />
      </div>
      <div class="drop-down">
        <p class="drop-header" @click="clickSize (search)">{{search.name}}</p>
        <transition name="opacityLeave">
          <div class="condition-list" v-show="isShowSize">
            <div class="size-wrap" v-if="search.RingSize">
              <p
                class="size"
                :class="{'active':index1==activeIndex}"
                v-for="(item1, index1) in search.RingSize"
                :key="index1"
                @click="getSize (search, item1,item1.Name,index1) "
              >{{item1.Name}}</p>
            </div>
          </div>
        </transition>
      </div>
      <div class="search-btn" @click="ToSearch"></div>
    </div>
    <div class="hot-search">
      热搜词：
      <span
        v-for="(item ,index) in search.HotSearch"
        :key="index"
        @click="ToSearch(-1,item.Name)"
      >{{item.Name}}</span>
    </div>
  </div>
</template>
 <script >
import { GetSearchDir } from "../../assets/js/modules/indexApi";
import { GetHomeLabels } from "../../assets/js/modules/indexApi.js";


export default {
  data() {
    return {
      isShowSize: false,
      activeIndex: "0",
      name: "全部图片",
      search: {
        name: "全部图片",
        RingSize: [],
        HotSearch: []
      },
      TitleName: ""
    };
  },
  methods: {
    //实现点击哪个下拉框显示
    clickSize(item, index) {
      // this.i = index;
      this.isShowSize = !this.isShowSize;
    },
    //实现选取下拉值
    getSize(item, item1, id, index) {
      this.search.name = item1.Name;
      this.isShowSize = !this.isShowSize;
      this.name = id;
      this.activeIndex = index;
    },
    // 获取搜索数据
    GetSearchDir() {
      GetSearchDir().then(res => {
        if (res.data.Success) {
          if (!window.localStorage.userInfo) {
            res.data.Data.splice(1, 1);
          }
          this.search.RingSize = res.data.Data;
        }
      });
    },
    //  获取热收词标签
    getHomeLabels() {
      let data = {
        SkipCount: 6,
        MaxResultCount: 6
      };
      GetHomeLabels(data).then(
        res => {
          if (res.data.Success) {
            this.search.HotSearch = res.data.Data;
          }
        },
        error => {}
      );
    },
    // 跳转到搜索页面
    ToSearch(res,name) {
      if (res == -1) {
        this.$router.push({
            path: "/searchResList",
            query: { Name: "全部图片", TitleName:name }
          });
      } else {
        if (this.TitleName) {
          this.$router.push({
            path: "/searchResList",
            query: { Name: this.name, TitleName: this.TitleName }
          });
        }
      }
    }
  },
  mounted() {
    this.GetSearchDir();
    this.getHomeLabels();
  }
};
</script>

<style scoped>
.all-search {
  position: absolute;
  top: 195px;
  left: 50%;
  margin-left: -550px;
  z-index: 99;
  font-size: 18px;
}
.search {
  width: 1100px;
  height: 70px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 35px;
  margin: 0 auto;
  color: #333333;
}
.active {
  background: #6aa9ff;
  color: #fff;
}
.search-input {
  float: left;
  width: 780px;
  height: 40px;
  margin-top: 15px;
  border-right: 1px solid #999999;
}
.search-input input {
  width: 700px;
  height: 40px;
  border: none;
  background-color: transparent !important;
  padding-left: 40px;
  outline: none;
}
.search-input input:focus {
  background-color: transparent !important;
}

.drop-down {
  float: left;
  width: 144px;
  margin-top: 15px;
  text-align: center;
  line-height: 40px;
  cursor: pointer;
  position: relative;
}
.drop-header {
  background: url("../../assets/img/down_icon.png") no-repeat 110px center;
  text-align: left;
  padding-left: 30px;
}
.condition-list {
  overflow: hidden;
  background: rgba(255, 255, 255, 0.7);
  margin-top: 15px;
  position: absolute;
  width: 100%;
}
.size:hover {
  color: #fff;
  background: #6aa9ff;
}
.size-wrap {
  padding: 10px 0;
}
.opacityLeave-enter-active {
  animation-name: fold-in;
  animation-duration: 0.5s;
}
.opacityLeave-leave-active {
  animation-name: fold-out;
  animation-duration: 0.5s;
}
@keyframes fold-in {
  0% {
    height: 0;
  }

  100% {
    height: 150px;
  }
}
@keyframes fold-out {
  0% {
    height: 150px;
  }

  100% {
    height: 0;
  }
}
.search-btn {
  float: right;
  width: 170px;
  height: 70px;
  background: url("../../assets/img/search_icon.png") #6aa9ff no-repeat center
    center;
  border-radius: 35px;
  cursor: pointer;
}
.hot-search {
  color: #fff;
  padding-left: 40px;
  width: 1100px;
}
.hot-search span {
  display: inline-block;
  padding: 20px 24px 0;
  cursor: pointer;
}
.hot-search span:hover {
  text-decoration: underline;
}
</style>




// WEBPACK FOOTER //
// src/components/common/search.vue